import React from 'react';

import IndexedSettingsTabs from '../components/IndexedSettingsTabs';
import { SettingGroupGrid } from '../FormWidgets/SettingGroup';
import { ShowSetting } from '../FormWidgets/ShowSliderSetting';

export default function LightChannelTabs({
  ids,
  t,
  idPrefix,
  controller,
  controls,
  getFieldId,
  getValue,
  getControllerValue,
  getMin,
  disabled,
  isEnabled,
  renderToggle,
  renderInfo,
  renderPreview,
  appBarClassName,
  appBarStyle,
  groupId = 'lights_multiple'
}) {
  const items = ids.map((id) => ({ id, label: `${t('sub_zone')} ${id}` }));
  return (
    <IndexedSettingsTabs
      items={items}
      idPrefix={idPrefix}
      appBarClassName={appBarClassName}
      appBarStyle={appBarStyle}
      renderPanel={({ id }) => (
        <>
          {renderToggle?.(id)}
          {isEnabled?.(id) !== false && (
            <SettingGroupGrid controller={controller} id={groupId}>
              <ShowSetting
                id={getFieldId(id)}
                show="lights_max"
                controller={controller}
                cur_value={getValue(id)}
                controller_value={getControllerValue(id)}
                min={getMin?.(id)}
                controls={controls}
                disabled={typeof disabled === 'function' ? disabled(id) : disabled}
                valueActions={renderInfo?.(id)}
              />
            </SettingGroupGrid>
          )}
          {isEnabled?.(id) !== false && renderPreview?.(id)}
        </>
      )}
    />
  );
}
